import React from 'react';
import './theme/styles/classes.css';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { ChatPage } from './pages/ChatPage';
import { WaitlistGate } from './components/library/auth/WaitlistGate';
import { ThemeProvider } from './contexts/ThemeContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { JobProvider } from './contexts/JobContext';
import Homepage from './pages/Homepage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import TradingPage from './pages/TradingPage';
import IntradaySignalTestPage from './pages/IntradaySignalTestPage';
import DslAgentTestPage from './pages/DslAgentTestPage';
import MarketMonitorPage from './pages/market-monitor';
import StrategySystematicsPage from './pages/StrategySystematicsPage';
import JobsPage from './pages/JobsPage';
import { JobAdminGate } from './components/library/auth/JobAdminGate';
import { OrderTicketNavigationProvider } from './features/order-ticket/navigation/OrderTicketNavigationContext';
import { GlobalSessionProvider } from './contexts/GlobalSessionContext';
import { LayoutProvider } from './contexts/LayoutContext';
import './config/widgets'; // side-effect: registers all widgets

function AppContent() {
  const location = useLocation();
  
  // Determine if we're on a chat route
  const isChatRoute = location.pathname === '/chat' ||
                      (location.pathname !== '/home' &&
                       location.pathname !== '/about' &&
                       location.pathname !== '/privacy' &&
                       location.pathname !== '/terms' &&
                       location.pathname !== '/trading' &&
                       location.pathname !== '/dashboard' &&
                       location.pathname !== '/market-monitor' &&
                       location.pathname !== '/strategy-systematics' &&
                       location.pathname !== '/jobs' &&
                       location.pathname !== '/intradaysignaltest' &&
                       location.pathname !== '/dslagenttest');
  
  return (
    <OrderTicketNavigationProvider>
      <LayoutProvider>
      <div className={`App ${isChatRoute ? 'chat-layout' : ''}`}>
        <div className="app-content">
          <Routes>
            <Route path="/home" element={<Homepage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/dashboard" element={
              <Navigate to="/trading" replace />
            } />
            <Route path="/trading" element={
              <WaitlistGate>
                <TradingPage />
              </WaitlistGate>
            } />
            <Route path="/market-monitor" element={
              <WaitlistGate>
                <MarketMonitorPage />
              </WaitlistGate>
            } />
            <Route path="/strategy-systematics" element={
              <WaitlistGate>
                <StrategySystematicsPage />
              </WaitlistGate>
            } />
            <Route path="/jobs" element={
              <WaitlistGate>
                <JobAdminGate>
                  <JobsPage />
                </JobAdminGate>
              </WaitlistGate>
            } />
            <Route path="/intradaysignaltest" element={
              <WaitlistGate>
                <IntradaySignalTestPage />
              </WaitlistGate>
            } />
            <Route path="/dslagenttest" element={
              <WaitlistGate>
                <DslAgentTestPage />
              </WaitlistGate>
            } />
            <Route path="/chat" element={
              <WaitlistGate>
                <ChatPage />
              </WaitlistGate>
            } />
            <Route path="/:chatHash" element={
              <WaitlistGate>
                <ChatPage />
              </WaitlistGate>
            } />
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </div>
      </div>
      </LayoutProvider>
    </OrderTicketNavigationProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <JobProvider>
        <WebSocketProvider>
          <Router>
            <GlobalSessionProvider>
              <AppContent />
            </GlobalSessionProvider>
          </Router>
        </WebSocketProvider>
      </JobProvider>
    </ThemeProvider>
  );
}

export default App;
